import React from 'react';
import ReactSVG from 'react-svg';
import info from 'assets/svg/icon-info.svg';

export default function InfoIcon() {
  return (
    <ReactSVG src={info} className="info-icon-inline" />
  );
}
